import { isValid, parseISO } from 'date-fns';
import { isDate, isString } from 'lodash';
import { TimelineRefreshError } from './TimelineRefreshError';

/** Incremental searches require a valid timestamp; initialization owns full loading. */
export const validateTimelineRefreshTimestamp = (entity: string, lastFetchedAt: unknown): string => {
    const timestamp = isDate(lastFetchedAt)
        ? lastFetchedAt
        : isString(lastFetchedAt)
          ? parseISO(lastFetchedAt)
          : new Date(NaN);

    if (!isValid(timestamp)) {
        const invalidTimestampError = new TimelineRefreshError(entity, {
            reason: 'Missing or invalid lastFetchedAt'
        });
        throw invalidTimestampError;
    }

    const normalizedTimestamp = timestamp.toISOString();
    return normalizedTimestamp;
};
